

function saveConfiguration() {
    return expivi.saveConfiguration(2048, 2048, 'CUSTOM_CAMERA_POSITION', 'image/jpeg', {
        include_keys: true,
        "position": {
            "x": 0,
            "y": 0.0,
            "z": 1.4
        },
        "quaternion": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        }
    });
}

function validateConfiguration(configuration) {
    // Retrieve the locale parameter from the URL, defaulting to 'en' if not present
    const urlParams = new URLSearchParams(window.location.search);
    const websiteLocale = urlParams.get('locale') || 'nl';
    return new Promise(function (resolve, reject) {
        var attributes = configuration.configured_products[0].attributes;
        var preparedDesignAttr = attributes.find((attr) => attr.attribute_key === "prepared_design");

        var preparedDesign = preparedDesignAttr && preparedDesignAttr.attribute_value_key === 'prepared_design_yes';
        var valueCheckUpload = attributes.find((attr) => attr.attribute_key && attr.attribute_key.indexOf('upload_custom_design') >= 0);
        var valueCheckCreate = attributes.find((attr) => attr.attribute_key && attr.attribute_key.indexOf('create_custom_design') >= 0);

        valueCheckUpload = valueCheckUpload && valueCheckUpload.attribute_value_name;
        valueCheckCreate = valueCheckCreate && valueCheckCreate.attribute_value_name;

        var valid = preparedDesignAttr ?
            (preparedDesign ? valueCheckUpload : valueCheckCreate)
            :
            (valueCheckUpload || valueCheckCreate);

        if (!valid) {
            return reject({
                invalid: true,
                message: preparedDesign
                    ? websiteLocale === 'de' ? 'Bitte fügen Sie zuerst Ihr Design hinzu.' :
                      websiteLocale === 'nl' ? 'Voeg aub eerst uw ontwerp toe.' :
                      'Please add your design first.'
                    : websiteLocale === 'de' ? 'Das erstellte Design darf nicht leer sein.' :
                      websiteLocale === 'nl' ? 'Het gemaakte ontwerp mag niet blanco zijn.' :
                      'The created design must not be blank.'
            });
        }

        resolve(configuration);
    });
}

function createVariant(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function(createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];
            resolve(createResult);
        }).fail(reject);
    });
}

function addToCart(createResult) {
    return new Promise(function (resolve, reject) {

        const url = window.location.href;
        const searchParams = new URLSearchParams(window.location.search);
        const quantity = searchParams.get('quantity') || 1;

        const properties = {};
        Object.keys(createResult.options).forEach((key) => {
            properties['_'+key] = createResult.options[key];
        });

        let addJsResponse = {
            quantity,
            id: createResult.variant_id,
            properties: properties,
        };

        window[createResult.themeCallback](resolve, reject, addJsResponse, createResult);
    });
}

window.xpv_hooks_add_to_cart = function(context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    // Disable button
    if ($button[0].hasAttribute('disabled')) {
        return false;
    }
    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    return Promise.resolve()
        .then(function() {
            return saveConfiguration();
        })
        .then(function(configuration) {
            return validateConfiguration(configuration);
        })
        .then(function(result) {
            return createVariant(result);
        })
        .then(function(result) {
            return addToCart(result)
        })
        .then(function() {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }

            // Don't let expivi handle add to cart
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            if (error && error.invalid) {
                alert(error.message);
                return;
            }
            throw error;
        });
}